<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="170px" label-position="top" :disabled="preViewFlag">
      <el-form-item prop="checkedCities">
        <span slot="label" class="slot-label">一、方案选择</span>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="form.checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="item in cities" :label="item.value" :key="item.label">{{item.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-show="form.checkedCities.length>0 || this.$route.query.status === '2'">
        <span slot="label" class="slot-label">二、方案配置</span>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item v-if="form.checkedCities.includes('2')" title="阶梯奖励" name="2">
            <el-container>
                <el-aside width="60%">
                    <el-table border :data="form.infiledList2" v-model="form.infiledList2" :span-method="objectSpanMethod"
                              style="width: 95%">
                      <el-table-column min-width="70px">
                        <template>
                          <span>PE/审核完成个数</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="档次">
                        <template slot-scope="scope">
                          <span>第{{ scope.row.prizeNum }}档</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="完成数量">
                        <template slot-scope="scope">
                          <el-input size="mini" :min="1" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.finishCount"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="amt" label="奖励金额">
                        <template slot-scope="scope">
                          <el-input size="mini" :min="1" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.amt"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="coin" label="奖励翼币">
                        <template slot-scope="scope">
                          <el-input size="mini" :min="1" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.coin"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="rewardNum" label="奖励个数">
                        <template slot-scope="scope">
                          <el-input size="mini" :min="1" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" v-model.number="scope.row.rewardNum"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" min-width="40px">
                        <template slot-scope="scope">
                          <el-button type="danger" icon="el-icon-delete" title="删除一行" circle
                                     v-show="scope.$index === form.infiledList2.length-1 && form.infiledList2.length>1"
                                     @click.native.prevent="deleteRow(scope.$index, form.infiledList2,1)"
                                     size="small"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  <div class="self-add">
                    <i style="cursor: pointer;" v-show="form.infiledList2.length<20 && !preViewFlag" title="新增一行" class="el-icon-circle-plus-outline" @click="addRow(form.infiledList2,1)"></i>
                  </div>
                </el-aside>
                <el-main>
                  <el-row class="self-font">截止时间：</el-row>
                  <el-row>
                        <el-form-item prop="endTime2">
                        <el-radio v-model="form.followOrder2" label="2">
                            <el-date-picker
                              v-model="form.endTime2"
                              type="datetime"
                              format='yyyy-MM-dd HH:mm'
                              valueFormat='timestamp'
                              @focus="focus(1)"
                              :pickerOptions="pickerOptions"
                              placeholder="选择任务截止时间">
                            </el-date-picker>
                        </el-radio>
                        <el-radio v-model="form.followOrder2" label="1">跟随订单提交时间</el-radio>
                        </el-form-item>
                  </el-row>
                  <el-row class="self-font">适用流程：</el-row>
                  <el-row>
                    <el-form-item prop="applicationFlow2">
                      <el-checkbox-group v-model="form.applicationFlow2">
                        <el-checkbox label="3" name="applicationFlow2">PE</el-checkbox>
                        <el-checkbox label="4" name="applicationFlow2">审核</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-row>
                  <el-form label-width="100px" size="mini" :model="form">
                    <el-row v-show="this.$route.query.status === '2'">
                      <el-button type="primary" icon="el-icon-trophy-1" v-show="form.settleTime" @click="awardVisible2Fn">获奖名单</el-button>
                      <el-dialog :title="'阶段激励 发放日期：'+formatCnDate(form.settleTime)" :visible.sync="awardVisible2">
                        <el-table :data="gridData2">
                          <el-table-column property="trId" label="译员昵称"></el-table-column>
                          <el-table-column property="finishCount" label="完成数量"></el-table-column>
                          <el-table-column property="amt" label="奖励金额"></el-table-column>
                          <el-table-column property="coin" label="奖励翼币"></el-table-column>
                        </el-table>
                      </el-dialog>
                    </el-row>
                  </el-form>
                </el-main>
              </el-container>
          </el-collapse-item>
          <el-collapse-item v-if="form.checkedCities.includes('3')" title="累计完成PE订单数量排名激励" name="3">
            <el-container>
              <el-aside width="60%" style="padding: 20px">
                <el-row v-for="(it,thirdIndex) of dataList[0].planDetailList" :key="thirdIndex" class="self-input">
                  <el-col :span="18" offset="3"  v-if="thirdIndex===0" class="self-col">
                    <div>前
                      <el-input v-if="dataList[0].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                v-model.number="it.endSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{it.endSort}}</span>
                      名</div>
                    <div>
                      <el-input style="padding-left: 60px;" v-if="dataList[0].status === 1" size="mini" type="number" v-model.number="it.amt" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{it.amt}}</span>
                      元/人</div>
                    <div>
                      <el-input v-if="dataList[0].status === 1" size="mini" type="number" v-model.number="it.coin" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{it.coin}}</span>
                      翼币/人</div>
                  </el-col>
                  <el-col :span="19" :offset="2" class="self-col" v-else>
                    <div>
                      <el-input v-if="dataList[0].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                v-model.number="it.startSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{ it.startSort }}</span>
                      名——
                      <el-input v-if="dataList[0].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                v-model.number="it.endSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{ it.endSort }}</span>
                      名
                    </div>
                    <div>
                      <el-input v-if="dataList[0].status === 1" size="mini" type="number" v-model.number="it.amt" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{ it.amt }}</span>元/人
                    </div>
                    <div>
                      <el-input v-if="dataList[0].status === 1" size="mini" type="number" v-model.number="it.coin" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{ it.coin }}</span>翼币/人
                    </div>
                  </el-col>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle title="删除一行" v-if="thirdIndex===dataList[0].planDetailList.length - 1" v-show="dataList[0].planDetailList.length>3" @click="removeLine(dataList[0].planDetailList,thirdIndex)"></el-button>
                </el-row>
                <el-row v-if="dataList[0].status === 1">
                  <el-col style="text-align: center"><i class="el-icon-circle-plus" style="font-size: x-large;cursor: pointer" title="新增一行" v-show="dataList[0].planDetailList.length<20 && !preViewFlag" @click="addLine(dataList[0].planDetailList)"></i></el-col>
                </el-row>
              </el-aside>
              <el-main>
                <el-row class="self-font">截止时间：</el-row>
                <el-row>
                  <el-form-item prop="endTime3">
                    <el-radio v-model="form.followOrder3" label="2">
                      <el-date-picker
                        v-model="form.endTime3"
                        type="datetime"
                        format='yyyy-MM-dd HH:mm'
                        valueFormat='timestamp'
                        @focus="focus(2)"
                        :pickerOptions="pickerOptions"
                        placeholder="选择任务截止时间">
                      </el-date-picker>
                    </el-radio>
                    <el-radio v-model="form.followOrder3" label="1">跟随订单提交时间</el-radio>
                  </el-form-item>
                </el-row>
                <el-form label-width="100px" size="mini" :model="form">
                  <el-row v-show="this.$route.query.status === '2'">
                  <el-button type="primary" icon="el-icon-trophy-1" v-show="form.settleTime" @click="awardVisible3Fn">获奖名单</el-button>
                  <el-dialog :title="'累计完成PE订单数量排名 发放日期：'+formatCnDate(form.settleTime)" :visible.sync="awardVisible3">
                    <el-table :data="gridData3">
                      <el-table-column label="名次" width="150">
                        <template slot-scope="scope">
                          <span>{{scope.$index + 1}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="trId" label="译员昵称"></el-table-column>
                      <el-table-column property="finishCount" label="完成数量"></el-table-column>
                      <el-table-column property="amt" label="奖励金额"></el-table-column>
                      <el-table-column property="coin" label="奖励翼币"></el-table-column>
                    </el-table>
                  </el-dialog>
                </el-row>
                </el-form>
              </el-main>
            </el-container>
          </el-collapse-item>
          <el-collapse-item v-if="form.checkedCities.includes('4')" title="PE一次通过率最高排名激励" name="4">
            <el-container>
              <el-aside width="60%" style="padding: 20px">
                <el-row v-for="(it,thirdIndex) of dataList[1].planDetailList" :key="thirdIndex" class="self-input">
                  <el-col :span="18" offset="3"  v-if="thirdIndex===0" class="self-col">
                    <div>前
                      <el-input v-if="dataList[1].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                v-model="it.endSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{it.endSort}}</span>
                      名</div>
                    <div>
                      <el-input style="padding-left: 60px;" v-if="dataList[1].status === 1" size="mini" type="number" v-model.number="it.amt" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{it.amt}}</span>
                      元/人</div>
                    <div>
                      <el-input v-if="dataList[1].status === 1" size="mini" type="number" v-model.number="it.coin" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{it.coin}}</span>
                      翼币/人</div>
                  </el-col>
                  <el-col :span="19" :offset="2" class="self-col" v-else>
                    <div>
                      <el-input v-if="dataList[1].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                v-model="it.startSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{ it.startSort }}</span>
                      名——
                      <el-input v-if="dataList[1].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                v-model="it.endSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{ it.endSort }}</span>
                      名
                    </div>
                    <div>
                      <el-input v-if="dataList[1].status === 1" size="mini" type="number" v-model.number="it.amt" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{ it.amt }}</span>元/人
                    </div>
                    <div>
                      <el-input v-if="dataList[1].status === 1" size="mini" type="number" v-model.number="it.coin" controls-position="right" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                                :min="1"></el-input>
                      <span v-else>{{ it.coin }}</span>翼币/人
                    </div>
                  </el-col>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle title="删除一行" v-if="thirdIndex===dataList[1].planDetailList.length - 1" v-show="dataList[1].planDetailList.length>3" @click="removeLine(dataList[1].planDetailList,thirdIndex)"></el-button>
                </el-row>
                <el-row v-if="dataList[1].status === 1">
                  <el-col style="text-align: center"><i class="el-icon-circle-plus" style="font-size: x-large;cursor: pointer" title="新增一行" v-show="dataList[1].planDetailList.length<20 && !preViewFlag" @click="addLine(dataList[1].planDetailList)"></i></el-col>
                </el-row>
              </el-aside>
              <el-main>
                <el-row class="self-font">截止时间：</el-row>
                <el-row>
                  <el-form-item prop="endTime4">
                    <el-radio v-model="form.followOrder4" label="2">
                      <el-date-picker
                        v-model="form.endTime4"
                        type="datetime"
                        format='yyyy-MM-dd HH:mm'
                        valueFormat='timestamp'
                        @focus="focus(3)"
                        :pickerOptions="pickerOptions"
                        placeholder="选择任务截止时间">
                      </el-date-picker>
                    </el-radio>
                    <el-radio v-model="form.followOrder4" label="1">跟随订单提交时间</el-radio>
                  </el-form-item>
                </el-row>
                <el-form label-width="100px" size="mini" :model="form">
                  <el-row v-show="this.$route.query.status === '2'">
                  <el-button type="primary" icon="el-icon-trophy-1" v-show="form.settleTime" @click="awardVisible4Fn">获奖名单</el-button>
                  <el-dialog :title="'PE一次通过率最高排名 发放日期：'+formatCnDate(form.settleTime)" :visible.sync="awardVisible4">
                    <el-table :data="gridData4">
                      <el-table-column label="名次" width="150">
                        <template slot-scope="scope">
                          <span>{{scope.$index + 1}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="trId" label="译员昵称"></el-table-column>
                      <el-table-column property="finishCount" label="一次通过率"></el-table-column>
                      <el-table-column property="amt" label="奖励金额"></el-table-column>
                      <el-table-column property="coin" label="奖励翼币"></el-table-column>
                    </el-table>
                  </el-dialog>
                </el-row>
                </el-form>
              </el-main>
            </el-container>
          </el-collapse-item>
          <el-collapse-item v-if="form.checkedCities.includes('5')" title="累计完成审核订单排名激励" name="5">
            <el-container>
              <el-aside width="60%" style="padding: 20px">
                <el-row v-for="(it,thirdIndex) of dataList[2].planDetailList" :key="thirdIndex" class="self-input">
                  <el-col :span="18" offset="3"  v-if="thirdIndex===0" class="self-col">
                    <div>前
                      <el-input v-if="dataList[2].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini"
                                v-model="it.endSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{it.endSort}}</span>
                      名</div>
                    <div>
                      <el-input style="padding-left: 60px;" v-if="dataList[2].status === 1" size="mini" type="number" v-model.number="it.amt" controls-position="right"
                                :min="1"></el-input>
                      <span v-else>{{it.amt}}</span>
                      元/人</div>
                    <div>
                      <el-input v-if="dataList[2].status === 1" size="mini" type="number" v-model.number="it.coin" controls-position="right"
                                :min="1"></el-input>
                      <span v-else>{{it.coin}}</span>
                      翼币/人</div>
                  </el-col>
                  <el-col :span="19" :offset="2" class="self-col" v-else>
                    <div>
                      <el-input v-if="dataList[2].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini"
                                v-model.number="it.startSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{ it.startSort }}</span>
                      名——
                      <el-input v-if="dataList[2].status === 1" controls="false" type="number" class="self-mini" step="1" size="mini"
                                v-model.number="it.endSort" :min="1" :max="10000"></el-input>
                      <span v-else>{{ it.endSort }}</span>
                      名
                    </div>
                    <div>
                      <el-input v-if="dataList[2].status === 1" size="mini" type="number" v-model.number="it.amt" controls-position="right"
                                :min="1"></el-input>
                      <span v-else>{{ it.amt }}</span>元/人
                    </div>
                    <div>
                      <el-input v-if="dataList[2].status === 1" size="mini" type="number" v-model.number="it.coin" controls-position="right"
                                :min="1"></el-input>
                      <span v-else>{{ it.coin }}</span>翼币/人
                    </div>
                  </el-col>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle title="删除一行" v-if="thirdIndex===dataList[2].planDetailList.length - 1" v-show="dataList[2].planDetailList.length>3" @click="removeLine(dataList[2].planDetailList,thirdIndex)"></el-button>
                </el-row>
                <el-row v-if="dataList[2].status === 1">
                  <el-col style="text-align: center"><i class="el-icon-circle-plus" style="font-size: x-large;cursor: pointer" title="新增一行" v-show="dataList[2].planDetailList.length<20 && !preViewFlag" @click="addLine(dataList[2].planDetailList)"></i></el-col>
                </el-row>
              </el-aside>
              <el-main>
                <el-row class="self-font">截止时间：</el-row>
                <el-row>
                  <el-form-item prop="endTime5">
                    <el-radio v-model="form.followOrder5" label="2">
                      <el-date-picker
                        v-model="form.endTime5"
                        type="datetime"
                        format='yyyy-MM-dd HH:mm'
                        valueFormat='timestamp'
                        @focus="focus(4)"
                        :pickerOptions="pickerOptions"
                        placeholder="选择任务截止时间">
                      </el-date-picker>
                    </el-radio>
                    <el-radio v-model="form.followOrder5" label="1">跟随订单提交时间</el-radio>
                  </el-form-item>
                </el-row>
                <el-form label-width="100px" size="mini" :model="form">
                  <el-row v-show="this.$route.query.status === '2'">
                  <el-button type="primary" icon="el-icon-trophy-1" v-show="form.settleTime" @click="awardVisible5Fn">获奖名单</el-button>
                  <el-dialog :title="'累计完成审核订单排名 发放日期：'+formatCnDate(form.settleTime)" :visible.sync="awardVisible5">
                    <el-table :data="gridData5">
                      <el-table-column label="名次" width="150">
                        <template slot-scope="scope">
                          <span>{{scope.$index + 1}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column property="trId" label="译员昵称"></el-table-column>
                      <el-table-column property="finishCount" label="完成数量"></el-table-column>
                      <el-table-column property="amt" label="奖励金额"></el-table-column>
                      <el-table-column property="coin" label="奖励翼币"></el-table-column>
                    </el-table>
                  </el-dialog>
                </el-row>
                </el-form>
              </el-main>
            </el-container>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>
      <el-form-item v-show="form.checkedCities.length>0 || this.$route.query.status === '2'" >
        <span slot="label" class="slot-label">三、选择订单</span>
        <el-button type="primary" @click="chooseOrder">选择</el-button>
        <div style="padding: 10px" v-show="orderDataList.length>0">
        <!--   todo 展示用订单      -->
          <avue-crud ref="crud"
                     :data="orderDataList"
                     :option="orderViewOption"
                     v-model="form2"
                     :search.sync="search"
                     @current-change="currentChange">
            <template slot="pmName" slot-scope="scope">
              <span>{{
                  pmOptions.find(it => it.username === scope.row.pmName) ? pmOptions.find(
                    it => it.username === scope.row.pmName).label : '--'
                }}</span>
            </template>
            <template slot="limitTime" slot-scope="scope">
              <span>{{ scope.row.limitTime?formatDate(scope.row.limitTime):'--' }}</span>
            </template>
          </avue-crud>
        </div>
      </el-form-item>
      <el-form-item v-show="form.checkedCities.length>0 && orderDataList.length>0 || this.$route.query.status === '2'">
        <span slot="label" class="slot-label">四、费用分配</span>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ocRatio">
              <el-input :disabled="form.status !== 1" controls="false" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                        class="self-mini" step="1" size="mini"
                        v-model.number="form.ocRatio" :min="0" :max="100">
                <template slot="prepend">运营</template>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="pmRatio">
              <el-input :disabled="form.status !== 1" size="mini" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                        v-model.number="form.pmRatio" controls-position="right"
                        :min="0" :max="100" step="1">
                <template slot="prepend">PM</template>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="riskRatio">
              <el-input :disabled="form.status !== 1" size="mini" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                        v-model.number="form.riskRatio" controls-position="right"
                        :min="0" :max="100" step="1">
                <template slot="prepend">风控</template>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            </el-col>
        </el-row>
      </el-form-item>
      <el-form-item v-show="form.checkedCities.length>0 && preViewFlag">
        <el-row>
          <el-col :span="4" offset="9">
            <span class="self-font">{{!this.form.settleTime?'预计':'' }}花费：{{actualAmt?actualAmt: estimatedCost}}元</span>
          </el-col>
          <el-col :span="4" offset="1">
            <span class="self-font">花费翼币：{{ actualCoin?actualCoin:preYibi}}个</span>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <el-row style="text-align: center" v-show="this.$route.query.status === '1'">
      <el-col :span="1" :offset="10">
        <el-button :type="!preViewFlag?'success':'text'" plain
                   @click="!preViewFlag?preView('form'):preViewFlag=false">{{
            !preViewFlag ? '方案预览' : '返     回'
          }}
        </el-button>
      </el-col>
      <el-col :span="1" offset="1">
        <el-button type="primary" @click="onSubmit('form')">发  布</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-show="this.$route.query.status === '2' && status === 1">
      <el-col :span="12" :offset="10">活动审核中,请稍后查看</el-col>
    </el-row>
    <el-row :gutter="20" v-show="this.$route.query.status === '2' && status === 2">
      <el-col :span="12" :offset="10">活动进行中,请跟踪活动效果</el-col>
    </el-row>
    <el-row :gutter="20" v-show="this.$route.query.status === '2' && status === 4">
      <el-col :span="12" :offset="10">审核超时，活动未发布</el-col>
    </el-row>
    <el-row :gutter="20" v-show="this.$route.query.status === '2' && status === 3">
      <el-col :span="12" :offset="10">审核未通过，可重新配置活动</el-col>
    </el-row>
    <el-row :gutter="20" v-show="this.$route.query.status === '2' && status === 5">
      <el-col :span="12" :offset="10">活动已结束</el-col>
    </el-row>
    <el-row :gutter="20" v-show="this.$route.query.status === '2'">
      <el-col :span="12" :offset="11">
        <el-button type="primary" plain @click="$router.back(-1)">返回</el-button></el-col></el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      title="选择订单"
      width="80%"
      @close="dialogVisible">
      <!-- todo 选择用订单-->
      <avue-crud ref="crud"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 v-model="form3"
                 @on-load="getList"
                 @row-click="rowClick"
                 :search.sync="form3"
                 @search-change="searchChange"
                 @refresh-change="refreshChange"
                 @size-change="sizeChange"
                 @selection-change="selectionChange"
                 @current-change="currentChange">
        <template slot="orderId" slot-scope="scope">
                <el-radio v-model="selectRow"
                          :label="scope.row.orderId">
                  <span>{{scope.row.orderId}}</span>
                </el-radio>
        </template>
        <template slot="orderIdSearch" slot-scope="{size}">
            <el-input placeholder="订单号" :size="size" style="width:250px;" clearable v-model="form3.orderId" @keyup.enter.native="refreshChange"></el-input>
        </template>
        <template slot="pmName" slot-scope="scope">
          <span>{{pmOptions.find(it=>it.username === scope.row.pmName)?pmOptions.find(it=>it.username === scope.row.pmName).label:''}}</span>
        </template>
        <template slot="limitTime" slot-scope="scope">
          <span>{{ formatDate(scope.row.limitTime) }}</span>
        </template>
      </avue-crud>
      <div style="text-align: center">
        <el-button type="primary" @click="chooseOrderConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<style>
.self-input span {
  color: red;
}
.self-input .el-input__inner {
  width: 80px;
}
.self-input .self-mini .el-input__inner {
  width: 70px;
}
.self-input .el-input--mini{
  width: auto;
  /*flex: auto;*/
}
</style>
<style lang='scss' scoped>
:deep(.el-collapse-item__header){
  font-size: large;
  font-weight: 500;
}
.self-add {
  text-align: center;
  font-size: x-large;
}
.self-font{
  font-size: large;
  font-weight: 600;
}
:deep(.slot-label){
  font-size: x-large
}
.self-col{
  display: flex;
  justify-content: space-around
}
</style>
<script>
import {formatDate} from "@/util/date";
import {formatInt, toChinesNum} from "@/util/util";
import {OrderOption, orderViewOption} from "@/const/crud/events/eventData";
import {listByRoleCode} from "@/api/centralControl/ongoingTask";
import {getObj} from "@/api/admin/user"
import {addOperation, processTaskList,processTask, queryOperation,queryRewardByPlanId} from "@/api/events/eventData";
import {mapState} from "vuex";

const cityOptions = [{label:'阶梯激励',value: '2'}, {label:'累计完成PE数量',value: '3'},
  {label:'PE一次通过率',value: '4'}, {label:'累计完成审核数量',value: '5'}];
export default {
  data() {
    let validatePass = (rule, value, callback,f) => {
      if (value === '' && f) {
        callback(new Error('请选择日期'));
      } else if (value <= Date.now() && f) {
        callback(new Error('选择时间必须大于当前时间'));
      } else {
        callback();
      }
    };
    return {
      tempOrderDataList: [],
      actualAmt:null,
      actualCoin:null,
      status: '',
      selectRow:'',
      preViewFlag:this.$route.query.status === '2',
      rules: {
        // limitTime: [
        //   { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        // ],
        endTime2: [
          { validator: ((rule, value, callback)=>{validatePass(rule, value, callback,this.form.followOrder2 === '2')}), trigger: 'blur' }
        ],
        endTime3: [
          { validator: ((rule, value, callback)=>{validatePass(rule, value, callback,this.form.followOrder3 === '2')}), trigger: 'blur' }
        ],
        endTime4: [
          { validator: ((rule, value, callback)=>{validatePass(rule, value, callback,this.form.followOrder4 === '2')}), trigger: 'blur' }
        ],
        endTime5: [
          { validator: ((rule, value, callback)=>{validatePass(rule, value, callback,this.form.followOrder5 === '2')}), trigger: 'blur' }
        ],
        applicationFlow: [
          { type: 'array', required: true, message: '请至少选择一个适用流程', trigger: 'change' }
        ],
        applicationFlow2: [
          { type: 'array', required: true, message: '请至少选择一个适用流程', trigger: 'change' }
        ],
        checkedCities: [
          { type: 'array', required: true, message: '请至少选择一个方案', trigger: 'change' }
        ],
        ocRatio:[{ required: true, message: '请输入运营百分比', trigger: 'blur' }],
        pmRatio:[{ required: true, message: '请输入PM百分比', trigger: 'blur' }],
        riskRatio:[{ required: true, message: '请输入风控百分比', trigger: 'blur' }],
      },
      orderDataList:[],
      pmOptions: [],
      search: {
        text: '',
        pmId: '',
        sortType: null,
        riskLevel: null,
        language:null,
        pending:false
      },
      tableOption: OrderOption,
      orderViewOption: orderViewOption,
      tableLoading: false,
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      dialogVisible:false,
      activeNames:[],
      drawsNum:1,
      checkAll: false,
      // checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      awardVisible:false,
      awardVisible2:false,
      awardVisible3:false,
      awardVisible4:false,
      awardVisible5:false,
      gridData2: [],
      gridData3: [],
      gridData4: [],
      gridData5: [],
      form: {
        settleTime:null,
        followOrder:'2',
        followOrder2:'2',
        followOrder3:'2',
        followOrder4:'2',
        followOrder5:'2',
        drawsNum:1,
        infiledList:[{ prizeNum:'一',sort:1,amt: 0,coin:0,rewardNum:1},{ prizeNum:'二',sort:2,amt: 0,coin:0,rewardNum:1}],
        infiledList2:[{ finishCount:0,sort:1,prizeNum:'一',amt: 0,coin:0,rewardNum:1}],
        checkedCities:[],
        endTime:'',
        endTime2:'',
        endTime3:'',
        endTime4:'',
        endTime5:'',
        planId:'',
        type: [],
        applicationFlow2: [],
        status: 1,
        ocRatio:0,
        pmRatio:0,
        riskRatio:0,
      },
      form2:{},
      form3:{},
      dataList:[
        {
          status:1,
          planId:1,
          planDetailList:[
            {startSort:1,sort:1,endSort:5,amt:0,coin:0},
            {startSort:6,sort:2,endSort:10,amt:0,coin:0},
            {startSort:11,sort:3,endSort:20,amt:0,coin:0}
          ]
         },
        {
          status:1,
          planId:1,
          planDetailList:[
            {startSort:1,sort:1,endSort:5,amt:0,coin:0},
            {startSort:6,sort:2,endSort:10,amt:0,coin:0},
            {startSort:11,sort:3,endSort:20,amt:0,coin:0}
          ]
        },
        {
          status:1,
          planId:1,
          planDetailList:[
            {startSort:1,sort:1,endSort:5,amt:0,coin:0},
            {startSort:6,sort:2,endSort:10,amt:0,coin:0},
            {startSort:11,sort:3,endSort:20,amt:0,coin:0}
          ]
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    estimatedCost() {
      let jtjlMoney = this.form.checkedCities.includes('2')?this.form.infiledList2.reduce((pr,cu)=>{return cu.amt*cu.rewardNum+pr},0):0;
      let amt =  this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(it=>it.reduce((pr,cu)=>{return (cu.endSort-cu.startSort+1)*cu.amt+pr},0)).reduce((pre, item) => {
        return pre + item
      }, 0)
      return jtjlMoney + amt;
    },
    preYibi() {
      let jtjlYibi = this.form.checkedCities.includes('2')?this.form.infiledList2.reduce((pr,cu)=>{return cu.coin*cu.rewardNum+pr},0):0;
      let coin =  this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(it=>it.reduce((pr,cu)=>{return (cu.endSort-cu.startSort+1)*cu.coin+pr},0)).reduce((pre, item) => {
        return pre + item
      }, 0)
      return jtjlYibi + coin;
    },
    pmNameVal() {
      return this.pmOptions.find(it => it.username === this.detailObj.pmName) ? this.pmOptions.find(
        it => it.username === this.detailObj.pmName).label : '';
    },
    pages () {
      const pages = []
      this.dataList.forEach((item, index) => {
        const page = Math.floor(index / 3)//3代表3条为一行，随意更改
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })
      return pages
    }
  },
  methods:{
    awardVisible2Fn() {
      queryRewardByPlanId({planId:this.form.planId}).then(res=>{
        this.gridData2 = res.data.data;
      })
      this.awardVisible2 = true;
    },
    awardVisible3Fn() {
      queryRewardByPlanId({planId:this.dataList[0].planId}).then(res=>{
        this.gridData3 = res.data.data;
      })
      this.awardVisible3 = true;
    },
    awardVisible4Fn() {
      queryRewardByPlanId({planId:this.dataList[1].planId}).then(res=>{
        res.data.data.forEach(it=> it.finishCount = it.finishCount+'%');
        this.gridData4 = res.data.data;
      })
      this.awardVisible4 = true;
    },
    awardVisible5Fn() {
      queryRewardByPlanId({planId:this.dataList[2].planId}).then(res=>{
        this.gridData5 = res.data.data;
      })
      this.awardVisible5 = true;
    },
    changeCheckBox(val) {
      console.log(this.form.applicationFlow2)
    },
    filterFn(currentValue,index) {
      let a = this.form.checkedCities.includes('3')?'index === 0':'';
      let b = this.form.checkedCities.includes('4')?'index === 1':'';
      let c = this.form.checkedCities.includes('5')?'index === 2':'';
      return eval(a) || eval(b) || eval(c);
    },
    rowClick (row) {
      this.selectRow = row.orderId
      // this.orderDataList = [row];
      this.tempOrderDataList = [row];
    },
    checkAnyEmpty(objList) {
      let arr = [];
      objList.forEach(it=>{
        for (const key in it) {
          arr.push(it[key])
        }
      })
      return arr.includes('');
    },
    preView(formName) {
      let res = this.checkAnyEmpty(this.form.infiledList2) || this.checkAnyEmpty(
        this.dataList[0].planDetailList) || this.checkAnyEmpty(this.dataList[1].planDetailList)
        || this.checkAnyEmpty(this.dataList[2].planDetailList) || this.orderDataList.length === 0;
      let total = parseInt(this.form.riskRatio) + parseInt(this.form.pmRatio) + parseInt(this.form.ocRatio);
      this.$refs[formName].validate((valid) => {
        if (valid && !res) {
          if (this.form.checkedCities.includes('2') && this.form.infiledList2.length > 1) {
           let type =  typeof this.form.infiledList2.map(i=>i.finishCount).reduce((pre,cur)=>{
              if(cur<pre){
                return cur;
              }else{
                return false;
              }
            })
            if (type !== "boolean") {
              this.$message.error("阶梯奖励的完成数量必须按档次递增")
              return false;
            }
          }
          let find = this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(i=>i.find(i=>i.startSort>i.endSort)).find(it=>it!==null && it!==undefined);
          let orderArrangement = this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(i => i.reduce((pre, cur) => {
            if (cur.startSort - pre.endSort === 1) {
              return cur
            } else {
              return false
            }
          })).includes(false);
          let bothZero = this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(i=>i.find(i=>i.amt ===0 && i.coin===0)).find(it=>it!==null && it!==undefined);
          if (bothZero) {
            this.$message.error("存在奖励金额和奖励翼币同时为0的行！");
            return false;
          }
          if (orderArrangement) {
            this.$message.error("存在不连续的排名");
            return false;
          }
          if (find) {
            this.$message.error("存在结束名次大于开始名次的数据！");
            return false;
          }
          if (total !== 100) {
            this.$message.info("费用分配之和不等于100");
            return false;
          }
          this.preViewFlag = true;
          this.$message.success("方案预览")
        } else {
          this.preViewFlag = false;
          this.$message.info("请填写完整内容后预览")
          return false;
        }
      });
    },
    onSubmit(formName) {
      let res = this.checkAnyEmpty(this.form.infiledList2) || 
                this.checkAnyEmpty(this.dataList[0].planDetailList) || 
                this.checkAnyEmpty(this.dataList[1].planDetailList) || 
                this.checkAnyEmpty(this.dataList[2].planDetailList) || 
                this.orderDataList.length === 0;
      let total = parseInt(this.form.riskRatio) + parseInt(this.form.pmRatio) + parseInt(this.form.ocRatio);
      this.$refs[formName].validate((valid) => {
        if (valid && !res) {
          if (this.form.checkedCities.includes('2') && this.form.infiledList2.length > 1) {
            let type =  typeof this.form.infiledList2.map(i=>i.finishCount).reduce((pre,cur)=>{
              if(cur<pre){
                return cur;
              }else{
                return false;
              }
            })
            if (type !== "boolean") {
              this.$message.error("阶梯奖励的完成数量必须按档次递增")
              return false;
            }
          }
          let orderArrangement = this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(i => i.reduce((pre, cur) => {
            if (cur.startSort - pre.endSort === 1) {
              return cur
            } else {
              return false
            }
          })).includes(false);
          let bothZero = this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(i=>i.find(i=>i.amt ===0 && i.coin===0)).find(it=>it!==null && it!==undefined);
          if (bothZero) {
            this.$message.error("存在奖励金额和奖励翼币同时为0的行！");
            return false;
          }
          if (orderArrangement) {
            this.$message.error("存在不连续的排名");
            return false
          }
          let find = this.dataList.filter(this.filterFn).map(it=>it.planDetailList).map(i=>i.find(i=>i.startSort>i.endSort)).find(it=>it!==null && it!==undefined);
          if (find) {
            this.$message.error("存在结束名次大于开始名次的数据！");
            return false;
          }
          if (total !== 100) {
            this.$message.info("费用分配之和不等于100")
            return false
          }
          let msg = '';
          let maxTime = 0;
          if (this.form.checkedCities.includes('2') && this.form.followOrder2 === '1' || this.form.checkedCities.includes('3') && this.form.followOrder3 === '1' || this.form.checkedCities.includes('4') && this.form.followOrder4 === '1'
            || this.form.checkedCities.includes('5') && this.form.followOrder5 === '1') {
            msg = '预计订单提交后结束';
          } else {
            let timeArr = [];
            if (this.form.checkedCities.includes('2')) {
              timeArr.push(this.form.endTime2)
            }
            if (this.form.checkedCities.includes('3')) {
              timeArr.push(this.form.endTime3)
            }
            if (this.form.checkedCities.includes('4')) {
              timeArr.push(this.form.endTime4)
            }
            if (this.form.checkedCities.includes('5')) {
              timeArr.push(this.form.endTime5)
            }
            maxTime = timeArr.reduce((num1, num2) => {
              return num1 > num2 ? num1 : num2}
            )
            msg = '预计' + this.formatCnDate(maxTime) + '结束';
          }
          let dotOperation = {
            sourceId: this.orderDataList[0].sourceId,
            ocRatio: this.form.ocRatio,
            orderId: this.orderDataList[0].orderId,
            pmRatio: this.form.pmRatio,
            amt: this.estimatedCost,
            coin: this.preYibi,
            riskRatio: this.form.riskRatio,
            createId: this.userInfo.staffCode,
            endTime: maxTime
          };
          let planList = [];
          if (this.form.checkedCities.includes('2')) {
            planList.push({
              type: 1,
              followOrder:this.form.followOrder2,
              applicationFlow:this.form.applicationFlow2.join(),
              endTime: this.form.followOrder2 === '2' ? this.form.endTime2 : 0,
              planDetailList:this.form.infiledList2
            })
          }
          if (this.form.checkedCities.includes('3')) {
            planList.push({
              type: 2,
              followOrder:this.form.followOrder3,
              endTime:this.form.followOrder3 === '2' ?this.form.endTime3:0,
              planDetailList:this.dataList[0].planDetailList
            })
          }
          if (this.form.checkedCities.includes('4')) {
            planList.push({
              type: 3,
              followOrder:this.form.followOrder4,
              endTime:this.form.followOrder4 === '2' ?this.form.endTime4:0,
              planDetailList:this.dataList[1].planDetailList
            })
          }
          if (this.form.checkedCities.includes('5')) {
            planList.push({
              type: 4,
              followOrder:this.form.followOrder5,
              endTime:this.form.followOrder5 === '2' ?this.form.endTime5:0,
              planDetailList:this.dataList[2].planDetailList
            })
          }
          dotOperation.planList = planList;
          this.$confirm('活动预计花费人民币'+'<strong><span style="color: red">'+this.estimatedCost+'</span></strong>'+'元,翼币'+'<strong><span style="color: red">'+this.preYibi+'</span></strong>'+'个,审核通过后立即实施,'+'<strong><span style="color: red">'+msg+'</span></strong>', '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            addOperation(dotOperation).then(res=>{
              let code = res.data.data;
              if (code > 0) {
                this.$message({
                  type: 'success',
                  message: '发布成功!'
                });
                this.$router.go(-1);
              } else if (code === -1){
                this.$message.error("阶梯奖励方案存在时间交叉");
              } else if (code === -2){
                this.$message.error("累计完成PE订单数量排名激励方案存在时间交叉");
              } else if (code === -3){
                this.$message.error("PE一次通过率最高排名激励方案存在时间交叉");
              } else if (code === -4){
                this.$message.error("累计完成审核订单排名激励方案存在时间交叉");
              } else if (code === -5){
                this.$message.error("参数为空");
              } else if (code === -6){
                this.$message.error("pe任务不在进行中");
              } else if (code === -7) {
                this.$message.error("存在审批中活动");
              } else if (code === -11){
                this.$message.error("阶梯奖励方案设置不合理")
              } else if (code === -12){
                this.$message.error("累计完成PE订单数量排名激励方案设置不合理")
              } else if (code === -13){
                this.$message.error("PE一次通过率最高排名激励方案设置不合理")
              } else if (code === -14){
                this.$message.error("累计完成审核订单排名激励方案设置不合理")
              }
            })

          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          });
        } else {
          this.$message.info("请填写完整内容后发布")
          return false;
        }
      });
    },
    // 多选订单方法
    selectionChange(list){
      // this.tempOrderDataList = list;
      this.orderDataList = list;
      // this.$message.success('选中的数据'+ JSON.stringify(list.map(it=>it.orderId)));
    },
    chooseOrderConfirm() {
      this.orderDataList = this.tempOrderDataList;
      if (this.orderDataList.length > 0) {
        this.dialogVisible = false;
      } else {
        this.$message.info("请至少选择一个订单");
      }
    },
    formatDate(time) {
      let date = new Date(parseFloat(time))
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    },
    formatCnDate(time) {
      let date = new Date(parseFloat(time))
      return formatDate(date, 'yyyy年MM月dd日 hh:mm:ss')
    },
    refreshChange() {
      this.getList()
    },
    getList(page, params) {
      this.tableLoading = true
      processTaskList({orderId: this.form3.orderId}).then(res=>{
        this.tableData = res.data.data;
        this.tableLoading = false
      })
    },
    searchChange(form, done) {
      // console.log(form)
      this.form3 = form
      // this.page.currentPage = 1;//避免翻页了再搜索为空的情况，明明应该有数据
      this.getList(this.page, form)
      done()
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    currentChange(current) {
      this.page.currentPage = current
    },
    chooseOrder() {
      this.dialogVisible = true;
    },
    handleChange(val) {
      // console.log(val);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 20 === 0) {
          return {
            rowspan: 20,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    focus(type) {
      if (type === 0) {
        this.form.followOrder = '2';
      } else if(type === 1){
        this.form.followOrder2 = '2'
      } else if(type === 2){
        this.form.followOrder3 = '2'
      } else if(type === 3){
        this.form.followOrder4 = '2'
      } else {
        this.form.followOrder5 = '2'
      }
    },
    deleteRow(index, rows) {//删除改行
      rows.splice(index, 1);
    },
    addRow(tableData,type){
      if (type===1) {
        tableData.push({
          finishCount: 0,
          prizeNum: toChinesNum(tableData.length + 1),
          amt: 0,
          sort: tableData.length+1,
          coin: 0,
          rewardNum: 1
        });
      } else {
        tableData.push({
          prizeNum: toChinesNum(tableData.length + 1),
          amt: 0,
          sort: tableData.length+1,
          coin: 0,
          rewardNum: 1
        });
      }
    },
    handleCheckAllChange(val) {
      this.form.checkedCities = val ? ['2','3','4','5'] : [];
      this.activeNames = this.form.checkedCities;
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      this.activeNames = value;
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    reset(item) {
      let arr = [
        {startSort:0,   endSort:0, amt:0, coin:200},
        {startSort:0,   endSort:0, amt:0 ,coin:200},
        {startSort:0,   endSort:0, amt:0 ,coin:200}
      ]
      this.$set(item, 'config', [...arr]);
    },
    removeLine(config,index) {
      config.splice(index, 1);
    },
    addLine(config) {
      let a = config.find(i=>parseInt(i.startSort)>parseInt(i.endSort))
      if (!a) {
        config.push(
          {
            startSort: this.startMax(config),
            endSort: this.endMax(config),
            amt: 0,
            coin: 0,
            sort: config.length + 1
          });
      } else {
        this.$message.error("存在结束名次大于开始名次！")
      }
    },
    init() {
      // console.log('init')
    },
    startMax(config) {
      let reduce = config.reduce((n1,n2)=>{
        return parseInt(n1.endSort) > parseInt(n2.endSort) ? parseInt(n1.endSort) :parseInt(n2.endSort);
      });
      return parseInt(reduce) + 1;
    },
    endMax(config) {
      let reduce = config.reduce((n1,n2)=>{
        return parseInt(n1.endSort) > parseInt(n2.endSort) ? formatInt(parseInt(n1.endSort)+1,1,true) : formatInt(parseInt(n2.endSort)+1,1,true);
      });
      return parseInt(reduce)
    }
  },
  beforeCreate() {
    if (this.$route.query.status === "2") {//查看详情
      queryOperation({id:this.$route.query.id}).then(res=>{
        let data = res.data.data;
        let realName = '';
        if (data) {
          getObj(parseInt(data.createId)).then(rs=>{
            // realName = rs.data.data ? rs.data.data.realname : '未知';
            // todo orderDataList
            processTask({orderId: data.orderId}).then(res=>{
              this.orderDataList=[{
                orderId:data.orderId,
                custName:res.data.data? res.data.data.custName : '未知',
                pmName:res.data.data? res.data.data.pmName : '未知',
                sourceId: data.sourceId,
                limitTime: res.data.data? res.data.data.limitTime : ''
              }]
            })
          })
          this.status = data.status;
          this.form.ocRatio = data.ocRatio;
          this.form.pmRatio = data.pmRatio;
          this.form.riskRatio = data.riskRatio;
          this.form.checkedCities = data.planList.map(i => (i.type + 1) + '');
          this.form.settleTime = data.settleTime;
          this.activeNames = this.form.checkedCities;
          this.actualCoin = data.coin;
          this.actualAmt = data.amt;
          if (this.form.checkedCities.includes('2')) {
            let find = data.planList.find(i=>i.type===1);
            find.planDetailList.map((i, ind) => i.prizeNum = toChinesNum(ind + 1));
            this.form.infiledList2 = find.planDetailList;
            this.form.endTime2 = parseInt(find.endTime);
            this.form.followOrder2 = find.followOrder + '';
            this.form.planId = find.id;
            this.form.applicationFlow2 = find.applicationFlow.split(',')
          }
          if (this.form.checkedCities.includes('3')) {
            let find = data.planList.find(i=>i.type===2);
            this.form.endTime3 = parseInt(find.endTime);
            this.form.followOrder3 = find.followOrder + '';
            this.dataList[0].planDetailList = find.planDetailList;
            this.dataList[0].planId = find.id;
          }
          if (this.form.checkedCities.includes('4')) {
            let find = data.planList.find(i=>i.type===3);
            this.form.followOrder4 = find.followOrder + '';
            this.form.endTime4 = parseInt(find.endTime);
            this.dataList[1].planDetailList = find.planDetailList;
            this.dataList[1].planId = find.id;
          }
          if (this.form.checkedCities.includes('5')) {
            let find = data.planList.find(i=>i.type===4);
            this.form.followOrder5 = find.followOrder + '';
            this.form.endTime5 = parseInt(find.endTime);
            this.dataList[2].planDetailList = find.planDetailList;
            this.dataList[2].planId = find.id;
          }
        } else {
          this.$message.error("返回活动详情错误")
        }
      })
    }
    // console.log(this.$route.query.status,typeof this.$route.query.status);
    // console.log(this.userInfo)
  },
  watch:{
    'form.followOrder2':function (val, oldVal){
      if (val === '1') {
        this.form.endTime2 = '';
      }
    },
    'form.followOrder3':function (val, oldVal){
      if (val === '1') {
        this.form.endTime3 = '';
      }
    },
    'form.followOrder4':function (val, oldVal){
      if (val === '1') {
        this.form.endTime4 = '';
      }
    },
    'form.followOrder5':function (val, oldVal){
      if (val === '1') {
        this.form.endTime5 = '';
      }
    }
  },
  mounted() {
    // console.log(this.userInfo.staffCode);
  },
  beforeMount() {
    listByRoleCode(Object.assign({
      roleCode: "DOT_PM"
    })).then(res => {
      let result = res.data.data;
      this.pmOptions = result.map(it => {
        return {
          value: it.staffId,
          label: it.realname,
          username: it.username
        }
      });
    })

  },
}

</script>
